var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tooltip",on:{"click":_vm.buttonClick}},[(_vm.on)?_vm._t("on"):_vm._t("off"),_c('Tooltip',{attrs:{"text":_vm.on ? _vm.tooltipTextOn : _vm.tooltipTextOff}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }